<template>
  <header :class="headerClasses">
    <div class="grid grid--container">
      <nuxt-link class="header__logo" to="/">
        <Logo
          color="#465049"
          mark-color="primary"
          :size="isLargeScreen ? 30 : 26"
        />
      </nuxt-link>

      <button
        class="header__menu-trigger"
        type="button"
        @click="showMenu = !showMenu"
      >
        <ul class="hamburglar">
          <li class="hamburglar-1"></li>
          <li class="hamburglar-2"></li>
          <li class="hamburglar-3"></li>
        </ul>
        <span class="sr-only">Open menu</span>
      </button>

      <nav class="header__nav">
        <ul class="header__nav-list">
          <li>
            <nuxt-link class="header__nav-link" to="/pricing"
              >Pricing</nuxt-link
            >
          </li>
          <li>
            <nuxt-link class="header__nav-link" to="/blog">Blog</nuxt-link>
          </li>
          <li>
            <a class="header__nav-link" href="https://support.campsite.bio/en/"
              >Support</a
            >
          </li>
          <li>
            <nuxt-link class="header__nav-link" to="/contact-us"
              >Contact</nuxt-link
            >
          </li>
          <li v-if="!isLoggedIn">
            <a class="header__nav-link" href="https://app.campsite.bio/login"
              >Log in</a
            >
          </li>
          <template v-if="!isLoggedIn">
            <li class="header__nav-action">
              <Button
                color="#465049"
                href="https://app.campsite.bio/create-account"
                size="small"
                >Sign Up Free</Button
              >
            </li>
            <li class="header__nav-login-mob">
              <a
                class="header__nav-link"
                href="https://app.campsite.bio/create-account"
                >Sign Up Free</a
              >
            </li>
          </template>
          <template v-else>
            <li class="header__nav-action header__nav-action--first">
              <Button
                color="#465049"
                size="small"
                href="https://app.campsite.bio"
                >Account</Button
              >
            </li>
            <li class="header__nav-login-mob">
              <a class="header__nav-link" href="https://app.campsite.bio"
                >Account</a
              >
            </li>
          </template>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
import { getCookie } from '@/utils/cookies';
import { Button, Logo } from '@campsite-bio/component-lib';
import { useMediaQuery } from '@vueuse/core';

export default {
  components: {
    Button,
    Logo,
  },

  setup() {
    const isLargeScreen = useMediaQuery('(min-width: 544px)');

    return {
      isLargeScreen,
    };
  },

  data() {
    return {
      showMenu: false,
    };
  },

  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },

    headerClasses() {
      return {
        header: true,
        'show-menu': this.showMenu,
      };
    },
  },

  mounted() {
    if (process.client && getCookie('auth_token_')) {
      try {
        this.$store.dispatch('getUser');
      } catch (e) {
        // console.error(e);
      }
    }
  },

  watch: {
    $route() {
      this.showMenu = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  background: var(--g-color-light-green);
  color: var(--g-color-on-primary);
  height: 3.125rem;
  padding: 0;
  position: relative;
  z-index: 100;

  .grid {
    align-items: center;
    display: flex;
    height: 100%;
  }
}

.header__logo {
  display: inline-flex;
  text-decoration: none;
}

.header__menu-trigger {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--g-color-gray-800);
  margin-left: auto;
  padding: 0;

  &:hover,
  &:focus {
    color: var(--g-color-primary);
  }
}

.hamburglar {
  display: inline-block;
  list-style: none;
  padding-left: 0;
  margin: 0 0 0 0.3125rem;
  height: 1.6875rem;
  position: relative;
  vertical-align: middle;
  width: 2.1875rem;
}

.hamburglar-1,
.hamburglar-2,
.hamburglar-3 {
  background: currentColor;
  border-radius: var(--g-border-radius-standard);
  border-radius: Min(
    var(--g-border-radius-standard),
    var(--g-border-radius-min)
  );
  display: block;
  height: 0.25rem;
  left: 0;
  position: absolute;
  transition: all 200ms;
  width: 100%;
}

.hamburglar-1 {
  top: 0;
}

.hamburglar-2 {
  top: 0.625rem;
}

.hamburglar-3 {
  top: 1.25rem;
}

.show-menu {
  .hamburglar-2 {
    background: transparent;
    transform: translateX(-0.5rem);
  }

  .hamburglar-1 {
    transform: rotate(45deg);
    top: 41%;
  }

  .hamburglar-3 {
    transform: rotate(-45deg);
    top: 41%;
  }

  .header__nav {
    opacity: 1;
    visibility: visible;
    transform: translateX(0);
  }
}

.header__nav {
  background: #fff;
  bottom: 0;
  position: fixed;
  margin-left: auto;
  max-width: 21.875rem;
  opacity: 0;
  right: 0;
  top: 3.125rem;
  transition: all 300ms;
  transform: translateX(100%);
  visibility: hidden;
  z-index: 11;
  width: 90%;
}

.header__nav-list {
  list-style: none;
  margin: 0;
  padding-left: 0;
}

.header__nav-link,
.header__nav-account {
  border-bottom: 1px solid var(--g-color-gray-200);
  display: block;
  color: var(--g-color-black);
  font-family: var(--g-font-header-family);
  font-size: 1.125rem;
  font-weight: var(--g-font-header-weight);
  letter-spacing: var(--g-font-header-letter-spacing);
  padding: 0.625rem 1.5rem;
  text-decoration: none;

  &:hover,
  &:focus {
    color: var(--g-color-primary);
  }
}

.header__nav-action {
  display: none;
}

@media (min-width: 544px) {
  .header {
    height: 4rem;
  }

  .header__logo svg {
    height: 2.5rem;
    margin-right: 0.625rem;
    width: 3.125rem;
  }

  .header__nav {
    top: 4.375rem;
  }
}

@media (min-width: 768px) {
  .header__menu-trigger {
    display: none;
  }

  .header__nav {
    background: none;
    max-width: none;
    position: static;
    opacity: 1;
    transform: none;
    visibility: visible;
    width: auto;
  }

  .header__nav-list > .header__nav-header,
  .header__nav-list > .header__nav-login-mob {
    display: none;
  }

  .header__nav-list {
    display: flex;
    gap: 1rem;
  }

  .header__nav-action {
    display: inline-block;
    margin-left: 0.3125rem;
  }

  .header__nav-action--first {
    margin-left: 0;
  }

  .header__nav-link,
  .header__nav-account {
    border-bottom: none;
    color: var(--g-color-on-bg);
    font-size: 1rem;
    font-weight: 600;
    padding: 0.3125rem;
    text-decoration: none;

    &:hover,
    &:focus {
      color: var(--g-color-primary);
    }
  }

  .header__nav-link {
    font-size: 0.8125rem;
    margin-top: 0;
  }
}

@media (min-width: 992px) {
  .header__nav-link {
    font-size: 1rem;
  }
}
</style>
